import React, { createContext, useContext, useState, useCallback } from "react";

// Create context
const TransferNotificationsContext = createContext();

/**
 * Provider component for transfer notifications
 */
export const TransferNotificationsProvider = ({ children }) => {
  // Keep track of both the timestamp and the count
  const [refreshTimestamp, setRefreshTimestamp] = useState(Date.now());
  const [pendingCount, setPendingCount] = useState(0);
  const [previousCount, setPreviousCount] = useState(0);

  // Function to refresh the badge
  const refreshPendingTransfers = useCallback(() => {
    setRefreshTimestamp(Date.now());
  }, []);

  // Function to update the count with notification of changes
  const updatePendingCount = useCallback(
    (newCount) => {
      // Only trigger a refresh if the count actually changed
      if (newCount !== pendingCount) {
        setPreviousCount(pendingCount);
        setPendingCount(newCount);
      }
    },
    [pendingCount]
  );

  return (
    <TransferNotificationsContext.Provider
      value={{
        refreshTimestamp,
        refreshPendingTransfers,
        pendingCount,
        previousCount,
        updatePendingCount,
      }}
    >
      {children}
    </TransferNotificationsContext.Provider>
  );
};

/**
 * Hook to access the transfer notifications context
 * Use this in components that need to refresh the badge after actions
 */
export const useTransferNotifications = () => {
  const context = useContext(TransferNotificationsContext);

  if (context === undefined) {
    throw new Error(
      "useTransferNotifications must be used within a TransferNotificationsProvider"
    );
  }

  return context;
};
